import { useStaticQuery, graphql } from "gatsby"
import { useMemo, useCallback } from "react"

import { DEFAULT_STOREFRONT } from "../cart/constants"
import { parseStoryblokDate } from "../utils/storyblok"

export const useParseStoryBlokDate = (date?: string): Date | null => {
  const parsedDate = useMemo(() => parseStoryblokDate(date), [date])

  return parsedDate
}

export const useGetProducts = (): {
  allProduct: { edges: { node: YocoCom.SdkProduct }[] }
} => {
  const products = useStaticQuery(graphql`
    query Products {
      allProduct {
        edges {
          node {
            id
            externalId
            sku
            name
            short_name
            image
            unit_price_formatted
            unit_price_currency
            unit_price
            original_unit_price
            is_discounted
            is_available_on_payment_terms
            type
            is_listed_in_catalogue
            max_quantity_per_cart
            tax_policy
            tax_rate
            ribbon_text
            ribbon_class
            third_party_reviews {
              description
              name
              rating
              url
            }
            storefronts
            reason_not_available
          }
        }
      }
    }
  `)

  return products
}

export const useGetProductBySku = (): ((
  sku: string,
  storefront?: string
) => YocoCom.SdkProduct | null) => {
  const products = useGetProducts()

  const getProductBySku = useCallback(
    (sku: string, storefront = DEFAULT_STOREFRONT) => {
      const product = products.allProduct.edges.find((product) => {
        return (
          product.node.sku === sku &&
          product.node.is_listed_in_catalogue &&
          product.node.storefronts.includes(storefront)
        )
      })

      return product ? product.node : null
    },
    [products]
  )

  return getProductBySku
}
